export default {
  sidebar: {
    wallet: 'Wallet',
    transactions: 'Transactions',
    logout: 'Logout',
  },
  home: {
    currentBalance: 'Current wallet balance:',
    updatedAt: 'Updated:',
    columns: {
      amountYesterday: 'Yesterday balance',
      amountToday: 'Today balance',
      paidAmount: 'Debit amount',
      addBalance: 'Wallet top-up',
      refundedAmount: 'Refund amount',
      date: 'Date',
    },
  },
  transactions: {
    columns: {
      agent: 'Agent',
      phone: 'Phone number',
      amount: 'Amount',
      transactionType: 'Transaction type',
      statusDescription: 'Status description',
      updatedAt: 'Updated at',
    },
  },
  table: {
    pageSize: 'Page size',
    datePlaceholder: 'Select date',
    export: 'Export',
    of: 'of',
    errorLoading: 'Error loading table data!',
  },
}
